// extracted by mini-css-extract-plugin
module.exports = {"root":"CardTimer_root__h_1jj","counter":"CardTimer_counter__Hsv2v","mobileItem":"CardTimer_mobileItem__Nc6aF"};